import ProductHideLayout from '@/features/products/hide';
import { PageLayout } from '@/layouts/shared';
import withAuthServerSideProps from '@/libs/auth';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

const ProductHidePage = () => {
  return <ProductHideLayout />;
};
export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.New,
        ...(await serverSideTranslations(locale as string, ['layout', 'product'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ProductHidePage;
